<div
  class="chat-wrapper"
  [class.type-received]="type === 'received'"
  [class.type-sent]="type === 'sent'"
  [class.from-you]="sentFromYou && type === 'sent'"
>
  <ng-container *ngIf="shouldShowProfilePic">
    <div class="avatar-wrapper">
      <div class="avatar">
        <glxy-avatar
          [src]="profilePicUrl"
          [icon]="profileIcon"
          [svgIcon]="profileSVGIcon"
          [width]="36"
          [name]="messageFrom"
          [backgroundColor]="profileBackgroundColor"
        ></glxy-avatar>
        <ng-container *ngIf="profileSourceIconName">
          <div [ngClass]="['profile-source-icon', 'source-' + profileSourceIconName]"></div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <div class="chat-bubbles">
    <div class="chat-from-info">
      <strong>{{ sentFromYou ? ('GALAXY.CHAT.YOU' | translate) : messageFrom }}</strong>
      <span *ngIf="messageFrom && messageMetadata">&nbsp;</span>
      <span *ngIf="messageMetadata">{{ messageMetadata }}</span>
    </div>

    <ng-content></ng-content>

    <ng-container *ngIf="isTyping">
      <glxy-chat-message [isTyping]="true" />
    </ng-container>
  </div>
</div>
